import { Modal, Spin } from "antd";
import { useEffect, useState } from "react";

import { openNotification } from "../../../../components/Notification";
import { denuncianteService } from "../../../../services/resources/denuncianteService";
import { possuiEncaminhamento } from "../../../../utils";

export function AlertaEncaminhamentoArquivarModal({
  protocolo,
  tipoLabel,
  onConfirm,
  onAbort,
}) {
  return (
    <Modal
      title={<strong>Atenção</strong>}
      width="40vw"
      visible
      centered
      onOk={onConfirm}
      onCancel={onAbort}
      okText="confirmar arquivamento"
      cancelText="abortar"
      okButtonProps={{ danger: true }}
    >
      <p>
        A {tipoLabel} <strong>{protocolo}</strong> que você pretende arquivar já
        possui encaminhamento. Deseja mesmo assim prosseguir?
      </p>
    </Modal>
  );
}

export function FluxoArquivarComAlerta({
  codigo,
  protocolo,
  tipoLabel = "denúncia",
  onClose,
  carregarRegistro = denuncianteService.getDenunciation,
  children,
}) {
  const [etapa, setEtapa] = useState("verificando");

  useEffect(() => {
    let ativo = true;

    carregarRegistro(codigo)
      .then(({ data }) => {
        if (!ativo) {
          return;
        }
        setEtapa(possuiEncaminhamento(data) ? "alerta" : "justificativa");
      })
      .catch((reason) => {
        if (!ativo) {
          return;
        }
        openNotification(
          "error",
          <strong>Não foi possível verificar os encaminhamentos.</strong>,
          reason?.response?.data?.detail
        );
        onClose();
      });

    return () => {
      ativo = false;
    };
    // A consulta deve ocorrer uma vez por denúncia aberta, não a cada render do pai.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigo]);

  if (etapa === "verificando") {
    return (
      <Modal
        title={<strong>Arquivar {tipoLabel}</strong>}
        width="40vw"
        visible
        centered
        footer={null}
        onCancel={onClose}
      >
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin />
        </div>
      </Modal>
    );
  }

  if (etapa === "alerta") {
    return (
      <AlertaEncaminhamentoArquivarModal
        protocolo={protocolo}
        tipoLabel={tipoLabel}
        onConfirm={() => setEtapa("justificativa")}
        onAbort={onClose}
      />
    );
  }

  return children;
}
